<template>
  <div class="wrap">
    <router-view
      ref="main"
      @showRenew="showRenew"
      @completeFcode="completeFcode"
      @getUser="userInfo"
    />

    <!-- F码-弹出层 -->
    <div
      class="pop-menu"
      @click="showPopName = ''"
      :class="{
        show: showPopName == 'barcode',
      }"
    >
      <div class="box" @click.stop>
        <div class="title">
          <span>使用F码</span>
          <i class="close" @click.stop="showPopName = ''"></i>
        </div>
        <guide-fcode
          ref="guidefcode"
          @robotChange="robotChange"
          @completeFcode="completeFcode"
          @orderPayShow="orderPayShow"
          @orderPayWeixinGuideShow="orderPayWeixinGuideShow"
          :robotList="robotList"
          :ticket="ticket"
          :isGuide="false"
        ></guide-fcode>
      </div>
    </div>
    <!-- 续费-弹出层 -->
    <div
      v-if="showPopName"
      class="pop-menu"
      @click="showPopName = ''"
      :class="{
        show: showPopName == 'shopping',
      }"
    >
      <div class="box renew-box" @click.stop>
        <div class="title">
          <span>续费功能</span>
          <i class="close" @click="showPopName = ''"></i>
        </div>
        <renew-box
          ref="renewbox"
          @robotChange="robotChange"
          @orderPayShow="orderPayShow"
          :ticket="ticket"
          :robotList="robotList"
        ></renew-box>
      </div>
    </div>
    <!-- 多开-弹出层 -->
    <div
      class="pop-menu"
      @click="showPopName = ''"
      :class="{
        show: showPopName == 'add',
      }"
    >
      <div class="box add-robot-box" @click.stop>
        <div class="title">
          <span>多开机器人</span>
          <i class="close" @click="showPopName = ''"></i>
        </div>
        <div class="content">
          <q>
            如您需要场控多个直播间，请点“增购机器人”；
            增加购买的机器人，可独立配置，并独立计费。
          </q>
          <div class="actions">
            <button class="button" @click="isShowAddRobot = true">
              增购机器人
            </button>
          </div>
          <div class="title">
            <span>示例：</span>
          </div>
          <div class="demo">
            <img src="../assets/pic/demo.jpg" alt="增购机器人演示" />
          </div>
        </div>
      </div>
    </div>
    <!-- 客服-弹出层 -->
    <div
      class="pop-menu"
      @click="showPopName = ''"
      :class="{
        show: showPopName == 'contact',
      }"
    >
      <div class="box service-box" @click.stop>
        <div class="title">
          <span>联系客服</span>
          <i class="close" @click="showPopName = ''"></i>
        </div>
        <div class="content">
          <ul class="service-way">
            <li>
              <a
                href="javascript:;"
                @click="
                  openUrl(
                    'http://wpa.qq.com/msgrd?v=3&amp;uin=3287126596&amp;site=qq&amp;menu=yes'
                  )
                "
              >
                <div class="img-box">
                  <img
                    src="../assets/pic/qrcode-qq.png"
                    alt="扫码添加小虎弟官方客服QQ"
                  />
                </div>
              </a>
            </li>
            <li>
              <div class="img-box">
                <img
                  src="../assets/pic/qrcode-wechat.png"
                  alt="扫码添加小虎弟官方客服微信"
                />
              </div>
            </li>
          </ul>
          <div class="title">
            <span>常见问题</span>
          </div>
          <div class="faq-list article">
            <ul>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/1.html')"
                  >电脑版如何使用</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/2.html')"
                  >手机版如何使用</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/3.html')"
                  >如何欢迎游客小白号</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/4.html')"
                  >如何开启语音读弹幕</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/5.html')"
                  >为什么有些智能答复出不来</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/6.html')"
                  >为什么看不到机器人说话</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/7.html')"
                  >AI互动为什么有时候不起作用</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/8.html')"
                  >拿来当场控的账号影响平时使用嘛</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/9.html')"
                  >房间号可以更改嘛</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/10.html')"
                  >为什么还是会欢迎一些广告号</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/11.html')"
                  >没到期可以续费嘛</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/12.html')"
                  >场控号为什么会续登失败</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/13.html')"
                  >为什么会出现欢迎答谢2次</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/14.html')"
                  >如何开启猜点数小游戏</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/15.html')"
                  >下播后如何让机器人继续工作</a
                >
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openUrl('https://www.xiaohudi.com/faq/16.html')"
                  >场控号为啥要添加房管权限</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 头像弹出层 -->
    <div
      class="pop-avatar"
      @click="isShowAvatar = false"
      :class="{
        show: isShowAvatar,
      }"
    >
      <div class="box" @click.stop>
        <span>{{ user.name || user.account}}</span>
        <button class="button" @click="logout">退出</button>
      </div>
    </div>
    <!-- 增购机器人弹出层 -->
    <div
      class="pop mask"
      @click="isShowAddRobot = false"
      :class="{
        show: isShowAddRobot,
      }"
    >
      >
      <div class="box add-robot-select" @click.stop>
        <div class="title">
          <span>增购机器人</span>
          <i class="close" @click="isShowAddRobot = false"></i>
        </div>
        <div class="content">
          <ul class="robot-type">
            <li class="client" @click="addRobot('client')">
              <div class="name">电脑版</div>
              <div class="price">￥29.9<small>/月</small></div>
            </li>
            <li class="cloud" @click="addRobot('cloud')">
              <div class="name">手机版</div>
              <div class="price">￥69.9<small>/月</small></div>
            </li>
          </ul>
          <div class="desc">请选择机器人版本</div>
          <div class="code-active">
            <el-link
              type="primary"
              id="use-code-input"
              @click="isInputRobotFcode = !isInputRobotFcode"
              >使用F码 增购机器人</el-link
            >
            <div
              class="code-input"
              :style="{
                display: isInputRobotFcode ? 'block' : '',
              }"
            >
              <div class="el-input">
                <!-- <input
                  type="text"
                  autocomplete="off"
                  placeholder="请输入内容"
                  class="el-input__inner"
                /> -->
                <el-input
                  placeholder="请输入内容"
                  v-model.trim="addRobotFcode"
                ></el-input>
              </div>
              <div class="actions">
                <button class="button" @click="actionRobotFCode">使用</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 菜单 -->

    <div class="nav">
      <div class="avatar" @click="isShowAvatar = !isShowAvatar">
        <div class="img-box">
          <img :src="user.portrait" alt />
        </div>
      </div>
      <ul class="menu">
        <li
          :class="{
            active: showPopName == item.eventClick,
          }"
          v-for="item in menuList"
          :key="item.className"
          @click="listClick(item.eventClick)"
        >
          <i :class="item.className">
            <i
              class="expired"
              v-if="item.eventClick == 'shopping' && isExpired"
            ></i
          ></i>
          <span>{{ item.title }}</span>
        </li>
      </ul>
    </div>
    <!-- <dialog-buy
      ref="dialogbuy"
      :productKey="productKey"
      :productName="productName"
      :productTips="productTips"
      @dialogClose="dialogBuyClose"
      @dialogPay="orderPayShow"
      @showVideo="showVideoDialog"
    ></dialog-buy>
    <dialog-pay
      ref="dialogpay"
      @dialogClose="dialogPayClose"
      @payCompleted="payCompleted"
      @robotAdd="getUserRobots"
    ></dialog-pay> -->
    <pay-box
      ref="dialogpay"
      @dialogClose="dialogPayClose"
      @payCompleted="payCompleted"
      @robotAdd="getUserRobots"
    ></pay-box>
  </div>
</template>

<script>
import {
  userInfo,
  consumeFCode,
  getFCode,
  getUserRobots,
  getWechatSdk,
  getRoomName,
  getAgentdata,
  createWechatPayOrder,
  createWechatPay,
  checkFcodeOrder,
} from "@/api/index";
import { Message } from "element-ui";
import payBox from "@/components/payBox";
import renewBox from "@/components/renewBox";
import guideFcode from "./guide/guideFcode";
import { mapState, mapActions } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      isShowAvatar: false,
      menuList: [
        {
          className: "icon-fcode",
          title: "F码",
          eventClick: "barcode",
        },
        {
          className: "icon-buy",
          title: "续费",
          eventClick: "shopping",
        },
        {
          className: "icon-add",
          title: "多开",
          eventClick: "add",
        },
        {
          className: "icon-qq",
          title: "客服",
          eventClick: "contact",
        },
      ],
      showPopName: "",
      isExpired: false, //是否有快过期的续费
      dialogShowInputFCode: false,
      ticket: "",
      formData: {
        FCode: "",
      },
      pName: "",
      productKey: "",
      productName: "",
      productTips: "",
      //视频说明
      videoUrl: "",
      isShowVideo: false,
      FCodeArray: [],
      isShowAddRobot: false,
      isInputRobotFcode: false,
      addRobotFcode: "",
      orderPayType: "normal",
      // robotLabel: ""
    };
  },
  components: {
    guideFcode,
    payBox,
    renewBox,
  },
  computed: {
    ...mapState({
      video: (state) => state.video,
      isPC: (state) => state.isPC,
      isWeixin: (state) => state.isWeixin,
      user: (state) => state.user,
      robotList: (state) => state.robotList,
      agentType: (state) => state.agentType,
      guideType: (state) => state.guideType,
    }),
    robotLabel() {
      let robotLabel = "";
      this.robotList.forEach((item, index) => {
        if (this.ticket == item.ticket) {
          robotLabel = `${item.label}${
            item.huyaUserName ? `-${item.huyaUserName}` : ""
          }`;
        }
      });
      return robotLabel;
    },
  },
  watch: {
    showPopName() {
      this.dialogPayClose();
      this.isShowAddRobot = false;
      this.isShowAvatar = false;
    },
    robotList(val) {
      this.isExpired = false;
      let index = -1;
      val.forEach((item, ind) => {
        if (item.timeRemaining <= 0 && index == -1) {
          index = ind;
          this.isExpired = true;
        }
      });
      this.ticket = val[index != -1 ? index : 0].ticket;
    },
  },
  created() {
    // if(localStorage.getItem('xhd_status') == 1){
    // }else{
    // this.getUserRobots();
    // }
    // new configListener();
  },
  mounted() {
    this.userInfo();
    if (this.isWeixin) {
      getWechatSdk(
        {
          url: location.href,
        },
        { notify: false }
      ).then((res) => {
        let data = res.data;
        wx.config({
          debug: data.debug,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: data.jsApiList,
        });
      });
    }
    if (this.$route.query.openFuc == "shopping") {
      this.showPopName = "shopping";
    }
  },
  methods: {
    ...mapActions([
      "updateUser",
      "updateAgentType",
      "changeLoadingStatus",
      "changeGuideType",
    ]),
    getUserRobots() {
      this.$refs.main.getUserRobots();
      // getUserRobots({ notify: false }).then(async res => {
      //   if (res.code === 0) {
      //     this.robotList = []
      //     this.ticket = res.data.robots[0].ticket
      //     for (let i = 0; i < res.data.robots.length; i++) {
      //       let val = res.data.robots[i]
      //       let index = i
      //       let huyaUserName = await this.getRoomName(val.roomId)
      //       this.robotList.push({
      //         label: `${index + 1}号机器人`,
      //         ticket: val.ticket,
      //         hasCloud: val.hasCloud,
      //         timeRemaining:
      //           Math.ceil(val.cloudExpired / 86400) == 0
      //             ? parseInt(val.cloudExpired / 86400)
      //             : parseInt(val.cloudExpired / 86400) + 1,
      //         runStatus: val.runStatus,
      //         roomId: val.roomId,
      //         huyaUserName
      //       })
      //     }
      //   }
      // })
    },
    userInfo() {
      userInfo(null, { notify: false }).then((res) => {
        if (res.code == -2050) {
          localStorage.removeItem("sid");
          if (this.$route.path != "/agent" && this.$route.path != "/login") {
            this.$router.replace({
              path: "/login",
              query: {
                redirect: "robotManager",
                t: this.$route.query.t || "",
                n: this.$route.query.n || "",
                openFuc: this.$route.query.openFuc || "",
              },
            });
          }
        } else {
          // this.user = res.data;
          // this.ticket = res.data.ticket;
          this.updateUser(res.data);
          if (!res.data.activated) {
            this.menuList.splice(2, 1);
          } else {
            this.changeGuideType("normal");
          }
          if (
            !res.data.activated &&
            !~location.href.indexOf("guide") &&
            this.$route.path != "/agent" &&
            this.guideType != "tryout"
          ) {
            this.$router.replace("/guideFcode");
            return;
          }
          // if (localStorage["guidePage"] && this.guideType != "tryout") {
          //   this.$router.replace(localStorage["guidePage"]);
          //   return;
          // }
          if (
            res.data.guide != 0 &&
            res.data.guide != 1 &&
            this.guideType != "tryout"
          ) {
            let path = ["/guideAccount", "/guideRate"];
            this.$router.replace(path[res.data.guide - 2]);
            return;
          }
          if (location.pathname == "/") {
            this.$router.replace("/robotManager");
          }
          if (this.$route.name == "agent" || this.$route.name == "promoters") {
            this.getAgentdata();
          }
        }
        this.changeLoadingStatus(false);
      });
    },
    getRoomName(roomid) {
      return getRoomName(
        {
          roomId: roomid,
        },
        { notify: false }
      ).then((res) => {
        if (res.code == 0) {
          return res.data;
        }
        if (res.code == 500) {
          this.$message({
            dangerouslyUseHTMLString: true,
            type: "error",
            message:
              '<strong>找不到这个主播</strong><p style="margin-top: 5px;">请确认房间号是否正确</p>',
          });
        }
      });
    },
    listClick(clickName) {
      if (
        !this.showPopName ||
        (this.showPopName && this.showPopName != clickName)
      ) {
        this.showPopName = clickName;
      } else {
        this.showPopName = "";
      }
    },
    showRenew(ticket) {
      this.ticket = ticket;
      this.showPopName = "shopping";
    },
    logout() {
      localStorage.removeItem("sid");
      localStorage.removeItem("avatar");
      localStorage.removeItem("user_name");
      this.$router.replace("/login");
    },
    hideDialog() {
      this.dialogShowInputFCode = false;
      this.showPopName = "";
      this.formData.FCode = "";
    },
    actionFCode(isEnd = true) {
      if (
        this.formData.FCode.length != 32 &&
        this.formData.FCode.length != 10
      ) {
        this.$message({
          dangerouslyUseHTMLString: true,
          type: "error",
          message:
            '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
        });
        return;
      }
      if (this.formData.FCode) {
        consumeFCode({
          fcode: this.formData.FCode,
          ticket: this.ticket,
        }).then((res) => {
          if (res.code == 0) {
            this.dialogShowInputFCode = false;
            this.showPopName = "";
            this.formData.FCode = "";
            this.pName = "";
            Message({
              showClose: true,
              message: "F码使用成功！",
              type: "success",
            });
            if (isEnd && this.guideType == "tryout") {
              this.completeFcode();
            } else {
              this.$refs.renewbox && this.$refs.renewbox.getOrderPags();
            }
          } else {
            if (res.code == 20004) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码错误</strong><p style="margin-top: 5px;">F码错误请重新输入</p>',
              });
              // '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
            }
            if (res.code == 20005) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是公会版F码，请下载公会版使用</p>',
              });
            }
            if (res.code == 20006) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">新手体验码每个账号只能使用一张</p>',
              });
            }
            if (res.code == 20007) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是单功能F码，无法用于新增机器人</p>',
              });
            }
            if (res.code == 20008) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已被使用，如有疑问，请联系客服</p>',
              });
            }
            if (res.code == 20015) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验码仅限原账号使用</p>',
              });
            }
            if (res.code == 20016) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已过期，体验卡请在24小时内使用</p>',
              });
            }
            if (res.code == 20017) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验卡仅限给发码机器人使用</p>',
              });
            }
          }
        });
      } else {
        Message({
          showClose: true,
          message: "请输入F码",
        });
      }
    },
    actionRobotFCode() {
      if (this.addRobotFcode) {
        consumeFCode({
          fcode: this.addRobotFcode,
          ticket: this.ticket,
          type: 1,
        }).then((res) => {
          if (res.code == 0) {
            this.isInputRobotFcode = false;
            this.showPopName = "";
            this.addRobotFcode = "";
            Message({
              showClose: true,
              message: "F码使用成功！",
              type: "success",
            });
            this.completeFcode();
          } else {
            if (res.code == 20004) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码错误</strong><p style="margin-top: 5px;">F码错误请重新输入</p>',
              });
              // '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
            }
            if (res.code == 20005) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是公会版F码，请下载公会版使用</p>',
              });
            }
            if (res.code == 20006) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">新手体验码每个账号只能使用一张</p>',
              });
            }
            if (res.code == 20007) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是单功能F码，无法用于新增机器人</p>',
              });
            }
            if (res.code == 20008) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已被使用，如有疑问，请联系客服</p>',
              });
            }
            if (res.code == 20015) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验码仅限原账号使用</p>',
              });
            }
            if (res.code == 20016) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已过期，体验卡请在24小时内使用</p>',
              });
            }
            if (res.code == 20017) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验卡仅限给发码机器人使用</p>',
              });
            }
          }
        });
      } else {
        Message({
          showClose: true,
          message: "请输入F码",
        });
      }
    },
    fcodeDialogClose() {
      this.formData.FCode = "";
      this.pName = "";
    },
    back() {
      // this.$router.replace("/robotManager");
      this.$router.go(-1);
    },
    getAgentdata() {
      getAgentdata().then((res) => {
        if (res.code == 0) {
          this.updateAgentType(res.data.type);
        }
      });
    },
    handleRenew(index, data) {
      if (data.timeAdd > data.products.length) {
        this.$message.warning("请选择续费时间");
        return;
      }
      this.orderPayShow({
        pkey: data.products[data.timeAdd].pkey,
        num: 1,
        channel: "wx",
        type: 1,
        email: "",
        ticket: this.ticket,
        price: (data.products[data.timeAdd].price / 100).toFixed(1),
        productName: data.name,
      });
    },
    orderPayShow(json, orderpaytype = "normal") {
      let self = this;
      json.ticket = this.ticket;
      this.orderPayType = orderpaytype;
      if (this.isWeixin && !this.isPC) {
        createWechatPayOrder(json).then((res) => {
          if (res.code == 1000) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>创建订单失败</strong><p style="margin-top: 5px;">错误码「1000」，请联系客服</p>',
            });
          }
          if (res.code == 20001) {
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message:
                '<strong>商品不存在</strong><p style="margin-top: 5px;">错误码「20001」，请联系客服</p>',
            });
          }
          let orderId = res.data.orderId;
          createWechatPay({
            order_id: orderId,
          }).then((payData) => {
            if (payData.code == 70003) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>微信登录授权过期</strong><p style="margin-top: 5px;">请刷新，重新登录配置后台</p>',
              });
            }
            if (payData.code == 1000) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>创建公众号订单失败</strong><p style="margin-top: 5px;">错误码「1000」，请联系客服</p>',
              });
            }
            if (payData.code == 0) {
              let data = payData.data;
              wx.chooseWXPay({
                timestamp: data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: data.paySign, // 支付签名
                success: function(res) {
                  // 支付成功后的回调函数
                  self.checkFcodeOrder(orderId);
                },
              });
            }
          });
        });
        return;
      }
      setTimeout(() => {
        this.$refs.dialogpay.showDialog(json);
      }, 0);
    },
    checkFcodeOrder(orderId) {
      checkFcodeOrder(
        {
          orderId: orderId,
        },
        { notify: false }
      ).then((res) => {
        if (res.code === 0) {
          if (res.data.paid) {
            if (!res.data.fcodes) {
              this.completeFcode();
            } else {
              this.FCodeArray = res.data.fcodes;
              this.actionFCodeArray();
            }
          }
        }
      });
    },
    actionFCodeArray() {
      this.FCodeArray.forEach((val, index) => {
        setTimeout(() => {
          this.formData.FCode = val.fcode;
          this.actionFCode(index == this.FCodeArray.length - 1);
          if (index == this.FCodeArray.length - 1) {
            this.FCodeArray = [];
          }
        }, 100);
      });
    },
    dialogPayClose() {
      this.$refs.dialogpay.hideDialog();
    },
    payCompleted(fcode, pkey = "") {
      if (this.orderPayType == "fcode") {
        this.$refs.guidefcode.payCompleted(fcode, pkey);
      } else {
        if (fcode && fcode.length) {
          this.FCodeArray = fcode;
          this.actionFCodeArray();
        } else {
          this.completeFcode();
        }
      }
    },
    addRobot(type) {
      this.productKey = type == "client" ? "robot" : "robot_cloud";
      this.productName = type == "client" ? "电脑版机器人" : "手机版机器人";
      // this.$refs.dialogbuy.showDialog('robot')
      this.$refs.dialogpay.showDialogOfBuy(this.productKey);
    },
    dialogBuyClose() {
      this.$refs.dialogbuy.hideDialog();
    },
    completeFcode() {
      this.changeGuideType("normal");
      this.showPopName = "";
      this.$refs.renewbox && this.$refs.renewbox.getOrderPags();
      this.$refs.main.payCompleted();
      this.sendDataChange();
      this.userInfo();
    },
    sendDataChange() {
      this.$refs.main.changeCurrentNotify(true);
      setTimeout(() => {
        this.$refs.main.changeCurrentNotify(false);
      }, 1000);
      this.$configListen.notify();
    },
    robotChange(val) {
      this.ticket = val;
    },
  },
};
</script>
<style lang="less" scoped>
.img-box {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
}
</style>